import { createApp } from 'vue'
import App from './App.vue'
import './style.css'
import i18n from './i18n'
import router from './router'
import { updatePageSeo } from './utils/seo'
import { watch } from 'vue'

const app = createApp(App)

const syncPageSeo = (route = router.currentRoute.value) => {
  updatePageSeo(route, i18n)
}

watch(
  () => i18n.global.locale.value,
  () => {
    syncPageSeo()
  }
)

router.afterEach((to) => {
  syncPageSeo(to)
})

syncPageSeo()

app.use(router).use(i18n).mount('#app')
